import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { X } from 'lucide-react';
import { memo } from 'react';
export const ShareList = /*#__PURE__*/ memo(function ShareList({ shares, onRemove, isLoading }) {
    if (shares.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "text-sm text-muted-foreground py-4 text-center",
            "data-testid": Testids.sharing.empty,
            children: "No one has access yet"
        });
    }
    return /*#__PURE__*/ _jsx("ul", {
        className: "space-y-2",
        "data-testid": Testids.sharing.list,
        children: shares.map((share)=>/*#__PURE__*/ _jsxs("li", {
                className: "flex items-center justify-between p-3 border border-border rounded-md",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm font-medium",
                                children: share.name
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-xs text-muted-foreground",
                                children: share.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-xs text-muted-foreground",
                                children: "Can view"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                onClick: ()=>onRemove(share.shareId),
                                disabled: isLoading,
                                className: "p-1 hover:bg-muted rounded disabled:opacity-50",
                                "aria-label": `Remove ${share.name}`,
                                children: /*#__PURE__*/ _jsx(X, {
                                    className: "w-4 h-4 text-muted-foreground"
                                })
                            })
                        ]
                    })
                ]
            }, share.shareId))
    });
});
